import { Component, Input } from "@angular/core";
import {
  casinoOfferLinks,
  languages,
} from "../../../../shared/constants/app-enums";
import { selectedLang } from "../../../../app.component";
import { TranslateService } from "@ngx-translate/core";
import { Location } from "@angular/common";
import { EventService } from "../../../../services/event.service";

@Component({
  selector: "app-casino-offer-header",
  templateUrl: "./casino-offer-header.component.html",
  styleUrls: ["./casino-offer-header.component.scss"],
})
export class CasinoOfferHeaderComponent {
  @Input() linkIndex = 0;
  @Input() enterSiteLink!: string;
  isMobile = (window.matchMedia &&  window.matchMedia('(max-device-width: 1024px)').matches) ||  screen.width <= 1024
  lang: any = localStorage.getItem('currentlang')
  languagesList: Array<any> = languages
  currentLanguage: any
  selectedLanguage: any
  hashKey: string = ''
  isRtoLSelected = false;
  
  constructor(
    private location: Location,
    private translate: TranslateService,
    private eventService: EventService
  ) {
    this.eventService.getLang().subscribe((val: any) => {
      this.currentLanguage = val || "en";
      this.selectedLanguage = this.languagesList.filter(
        (x) => x.value === this.currentLanguage,
      )[0];
      this.isRtoLSelected =
        this.selectedLanguage.value === "ar" ||
        this.selectedLanguage.value === "fa";
    })
  }
  ngOnInit(): void {
    if (!this.currentLanguage) {
      this.currentLanguage = selectedLang;
      this.selectedLanguage = this.languagesList.filter(x => x.value === this.currentLanguage)[0];
      this.isRtoLSelected =
        this.selectedLanguage.value === "ar" ||
        this.selectedLanguage.value === "fa";
    }
  }

  changeLanguage(requestLang: any): void {
    this.currentLanguage = requestLang;
    this.translate.use(this.currentLanguage);
    this.eventService.setLang(this.currentLanguage);
    this.selectedLanguage = this.languagesList.filter(
      (x) => x.value === this.currentLanguage,
    )[0];
    this.isRtoLSelected =
      this.selectedLanguage.value === "ar" ||
      this.selectedLanguage.value === "fa";
    this.replaceURL()
  }
  replaceURL(): void {
    const current_url = this.location.path().split("/");
    current_url.shift();
    current_url.splice(0, 1, this.currentLanguage);
    const new_url = current_url.join("/");
    this.hashKey = window.location.hash || "";
    this.location.replaceState("/" + new_url + this.hashKey);
  }

  getJoinNowLink() {
    return this.linkIndex - 1 >= 0 &&
      this.linkIndex - 1 < casinoOfferLinks.length
      ? casinoOfferLinks[this.linkIndex - 1]
      : casinoOfferLinks[0];
  }
}
